export default {
  acceptSimulatedDuration: 'Simulierte Dauer übernehmen',
  simulatedDuration: 'Simulierte Dauer',
  actualValue: 'Istwert',
};
